import { useMediaQuery } from 'react-responsive';

import { breakpoints } from 'constants/breakpoints';

/** Получение типа ширины устройства */
export function useDeviceWidth() {
    return {
        isDesktop: useMediaQuery({ minHeight: breakpoints.md, minWidth: breakpoints.md, orientation: 'landscape' }),
        isLG: useMediaQuery({ minWidth: breakpoints.lg, orientation: 'landscape' }),
        isLandscape: useMediaQuery({ orientation: 'landscape' }),
        isXL: useMediaQuery({ minWidth: breakpoints.xl, orientation: 'landscape' }),
    };
}
